import { useEffect, useState } from 'react'

import { IProgramGroup, IProgram } from '../../../types/program';
import { IUserInfo } from '../../../types/user';

import useGetProgram from '../../../hooks/user/useGetProgram';
import useGetScoreHypos from '../../../hooks/user/useGetScoreHypos';

import ProgramResult from './ProgramResult';


interface IProgramProps {
    applicantId: number;
    userId: number;
    applicant: string;
    user: IUserInfo | null;
}

export interface IProgramGroupProps {
    [name: string]: boolean;
};

const Programs = ({ applicantId, userId, applicant, user }: IProgramProps) => {

    const [programGroup, setProgramGroup] = useState<IProgramGroup | null>(null);
    const [accordion, setAccordion] = useState<IProgramGroupProps>({});
    const [program, setProgram] = useState<IProgram | null>(null);

    const { data: programData, isPending, isError } = useGetProgram(applicantId);
    const { data: hyposList } = useGetScoreHypos(userId);

    useEffect(() => {
        const oProgramData = programData ?? [];
        const groupedData = oProgramData.reduce((acc: any, obj: IProgram) => {
            const group = obj.group;
            if (!acc[group]) {
                acc[group] = [];
            }
            acc[group].push(obj);
            return acc;
        }, {});

        setProgramGroup(groupedData);
        let accordion: IProgramGroupProps = {}
        Object.keys(groupedData).forEach((key: any) => {
            if (key) accordion[key] = true
        });
        setAccordion(accordion)
        setProgram(programData ? programData[0] : null)
    }, [programData]); //eslint-disable-line

    if (isPending) return <div className="imm_consultant__loading"><div className="imm_consultant__process_loader" />Loading...</div>
    if (isError) return <div className="imm_consultant__loading">Programs are Not found</div>

    return (
        <div className='imm_program__main'>
            <div className="imm_program__left">
                {programGroup && Object.keys(programGroup).map((group: any, key: any) => {
                    if (group) {
                        return <div key={key} className={accordion[group] ? "imm_program__accordion active" : "imm_program__accordion"}>
                            <div className="imm_program__header" onClick={() => setAccordion({ ...accordion, [group]: !accordion[group] })}>{group}</div>
                            <div className="imm_program__content">
                                {programGroup[group] && programGroup[group].map((item: any, k: any) => {
                                    if (group === "express-entry") {
                                        return <div key={k}>
                                            <p className={item.id === program?.id ? "active" : ""} onClick={() => setProgram(item)}>{item.name}</p>
                                        </div>
                                    } else {
                                        return <div key={k}>
                                            <p className={(item.id === program?.id ? "active " : "") + (item.program_qualified ? "qualified " : "")} onClick={() => setProgram(item)}>{item.name}</p>
                                        </div>
                                    }
                                })}
                            </div>
                        </div>
                    }

                    return null;
                })}
            </div>
            <div className="imm_program__right">
                {program && (<ProgramResult hyposList={applicant === "main" ? (hyposList?.main ?? []) : (hyposList?.spouse ?? [])} program={program || {}} applicant={applicant} user={user || null} />)}
            </div>
        </div>
    );
}
export default Programs;